export default __webpack_public_path__ + "static/media/ms-logo.a29c12e1.png";